import { Injectable } from "../../node_modules/@angular/core";
import {
  HttpClient,
  HttpHeaders,
} from "../../node_modules/@angular/common/http";
import { Observable } from "../../node_modules/rxjs";

import { environment } from "../environments/environment";
import {
  NotificationModel,
  MessageModel,
  MediaModel,
  MediaEnqueteModel,
  MediaEnqueteRespostaUsuarioModel,
  MediaEnqueteResultadoModel,
} from "../model/NotificationModel";
import { of } from "rxjs/observable/of";

@Injectable()
export class NotificationService {
  constructor(private http: HttpClient) {}

  public listNotifications(
    clientId: number,
    userId: number
  ): Observable<Array<NotificationModel>> {
    return this.http.get<Array<NotificationModel>>(
      environment.apiHost +
        "/intermarketing/administration/notificacao/list/cliente/" +
        clientId +
        "/usuario/" +
        userId
    );
  }

  public getNotification(
    clientId: number,
    mensagemId: number
  ): Observable<MessageModel> {
    return this.http.get<MessageModel>(
      environment.apiHost +
        "/intermarketing/administration/mensagem/cliente/" +
        clientId +
        "/mensagem/" +
        mensagemId
    );
  }

  public listMedia(
    clientId: number,
    mensagemId: number
  ): Observable<Array<MediaModel>> {
    return this.http.get<Array<MediaModel>>(
      environment.apiHost +
        "/intermarketing/administration/midia/list/cliente/" +
        clientId +
        "/mensagem/" +
        mensagemId
    );
  }

  public getMedia(clientId: number, mediaId: number): Observable<MediaModel> {
    return this.http.get<MediaModel>(
      environment.apiHost +
        "/intermarketing/administration/midia/cliente/" +
        clientId +
        "/midia/" +
        mediaId
    );
  }

  public getEnquete(
    clientId: number,
    mediaId: number
  ): Observable<MediaEnqueteModel> {
    return this.http.get<MediaEnqueteModel>(
      environment.apiHost +
        "/intermarketing/administration/enquete/cliente/" +
        clientId +
        "/enquete/" +
        mediaId
    );
  }

  public getAllRespostaEnquete(
    clientId: number,
    userId: number,
    messageId: number,
    pollId: number,
    questions: Array<number>
  ): Observable<Array<MediaEnqueteRespostaUsuarioModel>> {
    let observableBatch = [];
    if (questions.length > 0) {
      questions.forEach((questionId) => {
        observableBatch.push(
          this.getRespostaEnquete(
            clientId,
            userId,
            messageId,
            pollId,
            questionId
          )
        );
      });
    } else {
      observableBatch.push(
        Observable.of(new Array<MediaEnqueteRespostaUsuarioModel>())
      );
    }
    return Observable.forkJoin(observableBatch);
  }

  public getRespostaEnquete(
    clientId: number,
    userId: number,
    messageId: number,
    pollId: number,
    questionId: number
  ): Observable<MediaEnqueteRespostaUsuarioModel> {
    return this.http
      .get<MediaEnqueteRespostaUsuarioModel>(
        environment.apiHost +
          "/intermarketing/administration/enquete/resultado/cliente/" +
          clientId +
          "/usuario/" +
          userId +
          "/mensagem/" +
          messageId +
          "/enquete/" +
          pollId +
          "/pergunta/" +
          questionId
      )
      .switchMap((response) => {
        return of(response);
      })
      .catch((err) => {
        if (err.status == 200) {
          return of(null);
        }
      });
  }

  public getAllResultadoPerguntaEnquete(
    clientId: number,
    messageId: number,
    pollId: number,
    questions: Array<number>
  ): Observable<Array<Array<MediaEnqueteResultadoModel>>> {
    let observableBatch = [];
    if (questions.length > 0) {
      questions.forEach((questionId) => {
        observableBatch.push(
          this.getResultadoPerguntaEnquete(
            clientId,
            messageId,
            pollId,
            questionId
          )
        );
      });
    } else {
      observableBatch.push(
        Observable.of(new Array<MediaEnqueteRespostaUsuarioModel>())
      );
    }
    return Observable.forkJoin(observableBatch);
  }

  public getResultadoPerguntaEnquete(
    clientId: number,
    messageId: number,
    pollId: number,
    questionId: number
  ): Observable<Array<MediaEnqueteResultadoModel>> {
    return this.http.get<Array<MediaEnqueteResultadoModel>>(
      environment.apiHost +
        "/intermarketing/administration/enquete/resultado/total/resposta/cliente/" +
        clientId +
        "/mensagem/" +
        messageId +
        "/enquete/" +
        pollId +
        "/pergunta/" +
        questionId
    );
  }

  public saveEnquete(
    model: MediaEnqueteRespostaUsuarioModel
  ): Observable<MediaEnqueteRespostaUsuarioModel> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http
      .post(
        environment.apiHost +
          "/intermarketing/administration/enquete/resultado/save",
        JSON.stringify(model),
        { headers: headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  public updateNotification(payload: NotificationModel): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post(
      environment.apiHost +
        "/intermarketing/administration/notificacao/publish",
      JSON.stringify(payload),
      { headers: headers, responseType: "text" }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/NotificationService.ts